@use "../../../styles/responsive";
@use "../../../styles/tokens";
@use "../../../styles/accessibility";

$component-name: "drawer";

.drawer {
  --ixf-drawer-margin: var(--ixf-space-2);
  --ixf-drawer-max-width: 480px;
  --ixf-drawer-height: calc(100dvh - (var(--ixf-drawer-margin) * 2));
  --ixf-drawer-border-radius: var(--ixf-border-radius-4);

  background-color: var(--ixf-color-background);
  box-shadow: var(--ixf-box-shadow-modal);
  border-radius: var(--ixf-drawer-border-radius);
  margin: var(--ixf-drawer-margin);
  height: var(--ixf-drawer-height);
  position: fixed;
  z-index: 9999;
  right: 0;
  bottom: 0;
  padding: var(--ixf-dialog-padding-vertical) 0 0;
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: var(--ixf-drawer-max-width);

  &.isExpanded {
    --ixf-drawer-max-width: calc(100% - (var(--ixf-drawer-margin) * 2));
  }

  &.withoutOverlay {
    box-shadow: none;
  }

  &.withoutAnimation {
    transition: none;
  }

  @media (max-width: tokens.$breakpoint-sm) {
    --ixf-drawer-max-width: calc(100% - (var(--ixf-drawer-margin) * 2));
    --ixf-drawer-margin: 0;
    --ixf-drawer-height: calc(100dvh - var(--ixf-space-7));
    --ixf-drawer-border-radius: var(--ixf-border-radius-4)
      var(--ixf-border-radius-4) 0 0;

    .expandButton {
      display: none;
    }
  }

  @keyframes prevent-ios-focus-scroll {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }

  input:focus {
    animation: prevent-ios-focus-scroll 0.01s;
  }

  .contentContainer {
    height: 100%;
    overflow: auto;
    padding: 0 var(--ixf-dialog-padding-horizontal);
    @include responsive.responsive-props(
      $component-name,
      "container-padding",
      "padding-top",
      false,
      true
    );
  }

  .innerContainer {
    position: relative;
    height: 100%;
  }

  .buttonRow {
    background-color: var(--ixf-color-background);
    box-shadow:
      0 -1px 4px 0 var(--ixf-color-background),
      0 -4px 16px 0 var(--ixf-color-background),
      0 -8px 32px 0 var(--ixf-color-background);
    margin-left: calc(var(--ixf-dialog-padding-horizontal) * -1);
    padding: 0 var(--ixf-dialog-padding-horizontal)
      var(--ixf-dialog-padding-vertical);
    width: calc(100% + (var(--ixf-dialog-padding-horizontal) * 2));
    flex: 0 0 auto;
    position: sticky;
    // z-index one less than interactive elements like input dropdowns
    z-index: 9998;
    bottom: 0;

    &[hidden] {
      display: none;
    }

    &.showBackground {
      background-color: var(--ixf-color-background);
    }

    @include responsive.responsive-props(
      $component-name,
      "container-padding",
      "margin-top",
      false,
      true
    );
  }
}

.overlay {
  position: fixed;
  inset: 0;
  z-index: 999;
  pointer-events: auto;

  &:not(.withoutOverlay) {
    background-color: var(--ixf-color-blackout-lt);
  }
}

.visuallyHidden {
  @include accessibility.visually-hidden;
}

.container {
  overflow: hidden;
  border-radius: var(--ixf-drawer-border-radius);
  display: flex;
  flex-direction: column;
}

.progressBar {
  position: absolute;
  top: 0;
  left: 0;
  height: 6px;
  background: var(--ixf-color-rainbow-gradient);
  box-shadow: 0 2px 2px rgba(255, 255, 255, 0.5) inset;

  @supports (color: color(display-p3 1 1 1)) {
    box-shadow: 0 2px 2px 0 color(display-p3 1 1 1 / 0.5) inset;
  }

  @media (prefers-reduced-motion: no-preference) {
    transition: width 200ms cubic-bezier(0.16, 1, 0.3, 1) 0s;
  }
}
